import { __assign, __makeTemplateObject, __rest } from "tslib";
import { TextArea as GrommetTextArea, } from 'grommet';
import * as React from 'react';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { monospace } from '../../utils';
var getBorderColor = function (props) {
    if (props.invalid) {
        return props.theme.colors.danger.main;
    }
    if (props.valid) {
        return props.theme.colors.success.main;
    }
};
var StyledGrommetTextArea = styled(GrommetTextArea)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\n\tpadding: 14px 20px;\n\tcolor: ", ";\n\tcursor: ", ";\n\tborder-color: ", ";\n\n\tresize: vertical;\n\tdisplay: block;\n\twidth: 100%;\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n"], ["\n\t", ";\n\n\tpadding: 14px 20px;\n\tcolor: ", ";\n\tcursor: ", ";\n\tborder-color: ", ";\n\n\tresize: vertical;\n\tdisplay: block;\n\twidth: 100%;\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n"])), monospace, function (props) { return props.theme.colors.text.main; }, function (props) { return (props.disabled ? 'not-allowed' : 'auto'); }, getBorderColor, function (props) { return props.theme.colors.tertiary.main; });
var BaseTextearea = function (_a) {
    var autoRows = _a.autoRows, maxRows = _a.maxRows, minRows = _a.minRows, rows = _a.rows, props = __rest(_a, ["autoRows", "maxRows", "minRows", "rows"]);
    var rowsProp = rows;
    if (autoRows && props.onChange) {
        rowsProp = (props.value || '').split('\n').length;
    }
    if (maxRows && (rowsProp || 0) > maxRows) {
        rowsProp = maxRows;
    }
    if (minRows && (rowsProp || 0) < minRows) {
        rowsProp = minRows;
    }
    var handleKeyUpDown = React.useCallback(function (e) {
        if (e.key === 'Enter') {
            e.stopPropagation();
        }
    }, []);
    return (React.createElement(StyledGrommetTextArea, __assign({ rows: rowsProp, onKeyDown: handleKeyUpDown, onKeyUp: handleKeyUpDown }, props)));
};
export var Textarea = asRendition(BaseTextearea);
var templateObject_1;
